import AXIOS from 'axios';
import { endpoints } from 'Api';

const loggerAxios = AXIOS.create();

const getBrowserInfo = () => navigator.userAgent || '';

const getOsInfo = () => {
  const ua = navigator.userAgent;
  if (ua.includes('Windows NT 10')) return 'Windows 10';
  if (ua.includes('Windows NT 11')) return 'Windows 11';
  if (ua.includes('Mac OS X')) return 'macOS';
  if (ua.includes('Linux')) return 'Linux';
  if (ua.includes('Android')) return 'Android';
  if (ua.includes('iPhone') || ua.includes('iPad')) return 'iOS';
  return 'Unknown OS';
};

const getScreenResolution = () => `${window.screen.width}x${window.screen.height}`;

/**
 * Logs an app event or error to the backend error tracking service.
 *
 * @param {Object} params
 * @param {string} params.userName           - Full name of the logged-in user (or 'Guest')
 * @param {string} params.functionAffected   - Feature/trigger name (e.g. 'Upload Thumbnail')
 * @param {string} params.description        - Human-readable summary of what happened
 * @param {'low'|'medium'|'high'} params.severity
 * @param {string} [params.errorMessage]     - raw_data.error_message
 * @param {string} [params.errorStack]       - raw_data.error_stack
 * @param {number} [params.responseStatus]   - raw_data.response_status
 * @param {string} [params.responseBody]     - raw_data.response_body
 * @param {string} [params.requestUrl]       - raw_data.request_url
 * @param {string} [params.requestMethod]    - raw_data.request_method
 * @param {string} [params.component]        - raw_data.component
 * @param {string} [params.userAction]       - raw_data.user_action
 */
export const logAppEvent = ({
  userName = 'Guest',
  functionAffected,
  description,
  severity = 'medium',
  errorMessage = null,
  errorStack = null,
  responseStatus = null,
  responseBody = null,
  requestUrl = null,
  requestMethod = null,
  component = null,
  userAction = null,
}) => {
  const payload = {
    website: 6,
    user_name: userName,
    function_affected: functionAffected,
    description,
    severity,
    browser_info: getBrowserInfo(),
    os_info: getOsInfo(),
    screen_resolution: getScreenResolution(),
    page_url: window.location.href,
    raw_data: {
      error_message: errorMessage,
      error_stack: errorStack,
      response_status: responseStatus,
      response_body: responseBody,
      request_url: requestUrl,
      request_method: requestMethod,
      timestamp: new Date().toISOString(),
      component,
      user_action: userAction,
    },
  };

  // Fire-and-forget: does not block the calling code, never throws
  loggerAxios.post(endpoints.logEvent, payload).catch(() => {});
};
